import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../content/ContentContext';

const Footer: React.FC = () => {
  const { footer, settings } = useContent();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-line">
      <div className="container-site py-14 md:py-16">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <img src={settings.logo} alt="Dartware GmbH" className="h-5 w-auto" />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-fg-3">{footer.description}</p>
          </div>
          {footer.columns.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h3 className="text-[13px] font-medium text-fg">{col.title}</h3>
              <ul className="mt-3 space-y-2">
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.external ? (
                      <a href={l.href} target="_blank" rel="noopener noreferrer" className="text-sm text-fg-3 transition hover:text-fg">{l.label}</a>
                    ) : l.href.startsWith('/#') || l.href.startsWith('#') ? (
                      <a href={l.href} className="text-sm text-fg-3 transition hover:text-fg">{l.label}</a>
                    ) : (
                      <Link to={l.href} className="text-sm text-fg-3 transition hover:text-fg">{l.label}</Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-col gap-2 border-t border-line pt-6 text-xs text-fg-3 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {footer.copyright}</p>
          <p>Entwickelt und betrieben in Deutschland.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
